import { FileIcon } from 'lucide-react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { EmptyState } from '@/shared/components/EmptyState';
import { useDownloadWorkspaceFile } from '../hooks/useDownloadWorkspaceFile';

/**
 * Shown for `binary` files instead of a preview.
 *
 * It repeats the header's download deliberately: for a file that cannot be
 * previewed, downloading it is the only thing to do here, and the one thing
 * the reader came for should not be a small control in the corner.
 */
export function UnpreviewableNotice({
  workspaceId,
  path,
  name,
}: {
  workspaceId: string;
  path: string;
  name: string;
}) {
  const { download } = useDownloadWorkspaceFile(workspaceId);

  return (
    <EmptyState
      className="m-3"
      icon={FileIcon}
      description={`A preview isn't available for “${name}”.`}
      action={
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            void download(path, name).catch(() => {
              toast.error('The file could not be downloaded.');
            });
          }}
        >
          Download
        </Button>
      }
    />
  );
}
